










import { Mixins, Component } from 'vue-property-decorator'
import ContactDetails from '@/views/Orders/Detail/ContactDetails.vue'
import Activity from '@/views/ReferralContact/Activity.vue'
import ReferralSidebar from '@/views/Tasks/Detail/ReferralSidebar.vue'

@Component({
    components: {
        Activity,
        ContactDetails,
    },
})
export default class OrderSidebar extends Mixins(ReferralSidebar) {}
